import { render, staticRenderFns } from "./paypal-buttons.vue?vue&type=template&id=2547cfb1&scoped=true"
import script from "./paypal-buttons.vue?vue&type=script&lang=js"
export * from "./paypal-buttons.vue?vue&type=script&lang=js"
import style0 from "./paypal-buttons.vue?vue&type=style&index=0&id=2547cfb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547cfb1",
  null
  
)

export default component.exports